import { render, staticRenderFns } from "./customer_case.vue?vue&type=template&id=38d440a8&scoped=true"
import script from "./customer_case.vue?vue&type=script&lang=js"
export * from "./customer_case.vue?vue&type=script&lang=js"
import style0 from "./customer_case.vue?vue&type=style&index=0&id=38d440a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d440a8",
  null
  
)

export default component.exports